import React from "react";

import PropTypes from "prop-types";

import {
  errorPanelContainer,
  textWrapperStyle,
  ctaWrapperStyle,
  ctaStyle,
  messageHeaderStyle,
  messageBodyStyle,
} from "./ErrorPanel.style";

const defaultErrorMessage = {
  messageHeader: "Something went wrong",
  messageBody:
    "Please go back and try again. Contact Customer Support if the problem continues.",
  cta: "https://support.newsela.com/contact/",
  ctaText: "Contact Customer Support",
};

export default function ErrorPanel({
  messageHeader,
  messageBody,
  cta,
  ctaText,
  ctaSecondary,
  ctaSecondaryText,
  headingLevel,
}) {
  const MessageHeading = headingLevel;
  const ctaButtonorLink = (link, text) => {
    return (
      <a aria-label={text} href={link} css={ctaStyle}>
        {text}
      </a>
    );
  };

  const renderCTA = (link, text) => {
    return (
      <a aria-label={text} href={link} css={ctaStyle}>
        {text}
      </a>
    );
  };
  return (
    <div css={errorPanelContainer}>
      <div css={textWrapperStyle}>
        <MessageHeading css={messageHeaderStyle}>
          {messageHeader}
        </MessageHeading>
        <div css={messageBodyStyle}>{messageBody}</div>
      </div>
      <div css={ctaWrapperStyle}>
        {renderCTA(cta, ctaText)}
        {ctaSecondaryText && ctaButtonorLink(ctaSecondary, ctaSecondaryText)}
      </div>
    </div>
  );
}

ErrorPanel.propTypes = {
  messageHeader: PropTypes.string,
  messageBody: PropTypes.string,
  /**
   * Call-to-action(CTA) path
   */
  cta: PropTypes.string,
  /**
   * Call-to-action(CTA) text
   */
  ctaText: PropTypes.string,
  /**
   * Second call-to-action(CTA) path
   */
  ctaSecondary: PropTypes.string,
  /**
   * Second call-to-action(CTA) text
   */
  ctaSecondaryText: PropTypes.string,
  /**
   * Heading element for the message. Nested regions such as side panels should
   * pass a lower level so they don't compete with the page's own h1.
   */
  headingLevel: PropTypes.oneOf(["h1", "h2", "h3"]),
};

ErrorPanel.defaultProps = {
  messageHeader: defaultErrorMessage.messageHeader,
  messageBody: defaultErrorMessage.messageBody,
  cta: defaultErrorMessage.cta,
  ctaText: defaultErrorMessage.ctaText,
  headingLevel: "h1",
};
